import * as $ from 'jquery';

window['jQuery'] = $;
window['$'] = $;

import 'jquery-ui/ui/widgets/datepicker';

window['moment'] = require('moment');

window['underscore'] = require('underscore');
window['_'] = window['underscore'];

import 'app/shared/notifications/smart-notification';
import 'jquery-mask-plugin';

